"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nunavutCities = void 0;
exports.nunavutCities = [
    {
        label: "Arctic Bay",
        value: 7547,
    },
    {
        label: "Arviat",
        value: 9013,
    },
    {
        label: "Baker Lake",
        value: 9012,
    },
    {
        label: "Bathurst Inl",
        value: 9018,
    },
    {
        label: "Bay Chimo",
        value: 9019,
    },
    {
        label: "Broughton I.",
        value: 9000,
    },
    {
        label: "Cambridge Bay",
        value: 7101,
    },
    {
        label: "Cape Dorset",
        value: 9001,
    },
    {
        label: "Chesterfield",
        value: 9014,
    },
    {
        label: "Clyde River",
        value: 9002,
    },
    {
        label: "Coppermine",
        value: 7548,
    },
    {
        label: "Coral Harbou",
        value: 9015,
    },
    {
        label: "Frobisher Bay",
        value: 7256,
    },
    {
        label: "Gjoa Haven",
        value: 9020,
    },
    {
        label: "Grise Fjord",
        value: 9003,
    },
    {
        label: "Hall Beach",
        value: 9004,
    },
    {
        label: "Igloolik",
        value: 9005,
    },
    {
        label: "Iqaluit",
        value: 7345,
    },
    {
        label: "Kimminut",
        value: 9006,
    },
    {
        label: "Kugluktuk",
        value: 9021,
    },
    {
        label: "Nanisivik",
        value: 9007,
    },
    {
        label: "Other",
        value: 9099,
    },
    {
        label: "Pangnittung",
        value: 9008,
    },
    {
        label: "Pelly Bay",
        value: 9049,
    },
    {
        label: "Pond Inlet",
        value: 9009,
    },
    {
        label: "Rankin Inlet",
        value: 9051,
    },
    {
        label: "Repulse Bay",
        value: 9016,
    },
    {
        label: "Resolute",
        value: 9010,
    },
    {
        label: "Sanikiluaq",
        value: 9011,
    },
    {
        label: "Taloyoak",
        value: 9022,
    },
    {
        label: "Whale Cove",
        value: 9017,
    },
];
